import { createApp } from "vue";
import { createPinia } from "pinia";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import App from "./App.vue";
import router from "./router";
import { usePermissStore } from "./store/permiss";
import "./assets/css/main.css";
import "element-plus/dist/index.css";
import "./assets/css/icon.css";
import "./assets/css/table.css";
const app = createApp(App);
app.use(createPinia());
app.use(router);
app.config.errorHandler = (error, vm, info) => {
  // 在这里处理错误，例如打印错误信息或发送错误报告
  console.error("Global Error Handler:", error, vm, info);
};
// 注册elementplus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
// 自定义权限指令
const permiss = usePermissStore();
app.directive("permiss", {
  mounted(el, binding) {
    if (!permiss.key.includes(String(binding.value))) {
      el["hidden"] = true;
    }
  },
});

app.mount("#app");
